import { createApp } from 'vue'
import App from './App.vue'

import cloudbase from '@cloudbase/js-sdk';

import router from './router'
import './registerServiceWorker'
import 'normalize.css'

import ElementPlus from 'element-plus';
import 'element-plus/lib/theme-chalk/index.css';

const app = createApp(App)
app.use(router)
app.use(ElementPlus)
app.use({
    install: () => {
        app.config.globalProperties.$TCB_App = cloudbase.init({
            env: 'project-museum-6gojwrvc77da9aee',
            timeout: 5000
        });
    }
});
app.config.globalProperties.$TCB_App
    .auth({
        persistence: "session",
    })
    .anonymousAuthProvider()
    .signIn()
    .then(() => {
        console.log("登录成功");
        // 登录成功
        app.mount('#app')
    })
    .catch((err) => {
        console.log(err);
        // 登录失败
    });